export default __webpack_public_path__ + "static/v2_ion_bw-f51b67d3b506707450eb302202ea41c0.jpg";